import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const glCodeTypesAdapter = getAdapter({ idFieldName: 'value' });

const glCodeTypesSlice = createSlice({
  name: 'glCodeTypes',
  initialState: glCodeTypesAdapter.getInitialState(),
  reducers: {
    setGlCodeTypes: (state, { payload: { glCodeTypes } }) => {
      glCodeTypesAdapter.setAll(state, glCodeTypes);
    },
  },
});

const selectors = glCodeTypesAdapter.getSelectors(({ glCodeTypes }) => glCodeTypes);

export const getGlCodeTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getGlCodeTypes = (state) => getGlCodeTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setGlCodeTypes,
} = glCodeTypesSlice.actions;

export default glCodeTypesSlice.reducer;